import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import OpenInNewIcon from '@material-ui/icons/OpenInNew';
export const _frontmatter = {
  "title": "Onshore Oil & Gas | How revenue works",
  "description": "The Federal Land Policy and Management Act of 1976 and the Mineral Leasing Act of 1920 grant BLM the authority to manage federal lands, including leasing certain lands for oil and gas development. The Oil and Gas Management Program oversees onshore oil and gas wells on federal lands.",
  "includeToc": false,
  "tags": ["How revenue works", "Onshore", "Oil", "Gas", "Process", "Resources"]
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageTabs = makeShortcode("PageTabs");
const PageTab = makeShortcode("PageTab");
const Box = makeShortcode("Box");
const Container = makeShortcode("Container");
const Grid = makeShortcode("Grid");
const BlmLogoImg = makeShortcode("BlmLogoImg");
const OnrrLogoImg = makeShortcode("OnrrLogoImg");
const OnshoreOilGasBackground = makeShortcode("OnshoreOilGasBackground");
const DidYouKnowCard = makeShortcode("DidYouKnowCard");
const CollapsibleContent = makeShortcode("CollapsibleContent");
const ProcessCard = makeShortcode("ProcessCard");
const GlossaryTerm = makeShortcode("GlossaryTerm");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <PageTabs mdxType="PageTabs">
  <PageTab alt={'Navigate to Offshore Oil and Gas'} to={'/how-revenue-works/offshore-oil-gas/'} mdxType="PageTab">
    Offshore
  </PageTab>
  <PageTab mdxType="PageTab">
    Onshore
  </PageTab>
    </PageTabs>
    <Box bgcolor='primary.main' mdxType="Box">
      <Container maxWidth="lg" mdxType="Container">
        <Grid container alignItems='center' mdxType="Grid">
          <Grid item xs={12} sm={8} mdxType="Grid">
            <Box p={3} pl={0} mdxType="Box">
              <p><a parentName="p" {...{
                  "href": "/sites/update-redirects/how-revenue-works/"
                }}>{`How revenue works /`}</a></p>

              <h1 {...{
                "id": "Onshore-Oil--Gas",
                "style": {
                  "position": "relative"
                }
              }}>{`Onshore Oil & Gas`}</h1>
              <p>{`The Bureau of Land Management (BLM) has the authority to manage federal lands. This authority includes leasing certain lands for oil and gas development.`}</p>
              <br />
This responsibility was granted by the Federal Land Policy and Management Act of 1976 and the Mineral Leasing Act of 1920. The Oil and Gas Management Program oversees onshore oil and gas wells on federal lands.
            </Box>
          </Grid>
          <Grid container xs={12} sm={4} mdxType="Grid">
            <Box p={3} border={4} borderTop={0} borderBottom={0} borderColor='white' mdxType="Box">
              <Grid container xs={12} mdxType="Grid">
                <Grid item xs={8} mdxType="Grid">
                  <p>{`Onshore oil and gas are managed and regulated by the `}<a parentName="p" {...{
                      "href": "https://www.blm.gov/"
                    }}>{`Bureau of Land Management `}<OpenInNewIcon style={{
                        fontSize: 20
                      }} mdxType="OpenInNewIcon" /></a>{` (BLM).`}</p>
                </Grid>
                <Grid item xs={4} mdxType="Grid">
                  <Box p={4} mdxType="Box"><BlmLogoImg mdxType="BlmLogoImg"></BlmLogoImg></Box>
                </Grid>
                <Grid item xs={8} mdxType="Grid">
                  <p>{`The `}<a parentName="p" {...{
                      "href": "http://www.onrr.gov/"
                    }}>{`Office of Natural Resources Revenue `}<OpenInNewIcon style={{
                        fontSize: 20
                      }} mdxType="OpenInNewIcon" /></a>{` (ONRR) manages some monetary transactions.`}</p>
                </Grid>
                <Grid item xs={4} mdxType="Grid">
                  <Box p={4} mdxType="Box"><OnrrLogoImg mdxType="OnrrLogoImg"></OnrrLogoImg></Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
    <OnshoreOilGasBackground mdxType="OnshoreOilGasBackground">
      <Grid container spacing={2} alignItems='flex-start' mdxType="Grid">
        <Grid item xs={12} sm={4} mdxType="Grid">
          <Box p={9} m={9} display={{
            xs: 'none',
            sm: 'block'
          }} mdxType="Box" />
          <Box p={8} display={{
            xs: 'block',
            sm: 'none'
          }} mdxType="Box" />
          <DidYouKnowCard mdxType="DidYouKnowCard">
            <p>{`Exploration for oil and gas changed significantly in the early 2000s, with new extraction methods of horizontal drilling and hydraulic fracturing. These methods are commonly known as “fracking.”`}</p>
            <CollapsibleContent mdxType="CollapsibleContent">
              <p>{`These methods made extracting oil and gas deep below the surface of the earth in shale rock formations profitable.`}</p>
              <br />
              <p>{`Hydraulic fracturing pumps water, sand, and chemicals into the earth to fracture the shale rock so that natural gas and oil can flow through the well to the surface.
Major oil and gas shale rock formations in the U.S. include:`}</p>
              <ul>
                <li parentName="ul">{`The Permian, Haynesville, and Eagle Ford Regions mostly in Texas.`}</li>
                <li parentName="ul">{`The Marcellus Region in West Virginia, Pennsylvania, and New York.`}</li>
                <li parentName="ul">{`The Niobrara Region in Wyoming and Colorado.`}</li>
                <li parentName="ul">{`The Bakken Region in North Dakota and Montana.`}</li>
              </ul>
            </CollapsibleContent>
          </DidYouKnowCard>
        </Grid>
        <Grid item xs={12} sm={1} mdxType="Grid">
        </Grid>
        <Grid item xs={12} sm={7} mdxType="Grid">
          <Box mt={5} mdxType="Box">
            <ProcessCard step={1} name={'Plan'} mdxType="ProcessCard">
              <p>{`BLM field offices prepare comprehensive Resource Management Plans (RMPs). RMPs guide leasing decisions on federal lands.  This specifies which lands are open to oil and gas leasing, and which lands are closed. BLM field offices develop RMPs in line with multiple-use and sustained-yield principles. BLM also engages the public and various levels of government.`}</p>
            </ProcessCard>
            <ProcessCard step={2} name={'Lease'} mdxType="ProcessCard">
              <p>{`BLM field offices award leases for oil and gas resources on lands designated within RMPs during live lease auctions open to the public.  Auctions are held frequently, often quarterly. Before the live auction, the BLM field office estimates the `}<GlossaryTerm mdxType="GlossaryTerm">{`fair market value`}</GlossaryTerm>{` for the natural resources in question.`}</p>
              <br />
              <p>{`During the live auction, bidders compete for a lease by placing bids. The BLM field office awards the lease to the highest bidder, so long as the bid is equal to or greater than the fair market value estimate. Once the BLM field office accepts a bid, the bidder must pay the `}<GlossaryTerm mdxType="GlossaryTerm">{`bonus`}</GlossaryTerm>{` as well as the first year’s rent to BLM to secure the lease.`}</p>
            </ProcessCard>
            <ProcessCard step={3} name={'Explore'} mdxType="ProcessCard">
              <p>{`The lease holder must file an Application for Permit to Drill (APD) with the BLM field office. An APD allows a lease holder to explore the leased land for oil and gas deposits. To apply for an APD, lease holders must submit an Exploration Plan. The Exploration Plan includes information about the well and associated rights of way, roads, pipelines, and production facilities. After the APD is filed, there is a mandatory 30-day public notification period before the permit can be approved.`}</p>
              <br />
              <p>{`While reviewing the APD, BLM analyzes the impact of drilling on the environment. BLM uses an `}<GlossaryTerm mdxType="GlossaryTerm">{`Environmental Impact Statement (EIS)`}</GlossaryTerm>{` or an Environmental Assessment in accordance with the National Environmental Policy Act. Before awarding the permit, BLM must also ensure that conditions for the National Historic Preservation Act and the Endangered Species Act are met. Once granted, the APD expires within two years. During the exploration phase, companies pay `}<GlossaryTerm mdxType="GlossaryTerm">{`rent`}</GlossaryTerm>{` to ONRR.`}</p>
            </ProcessCard>
            <ProcessCard step={4} name={'Develop'} mdxType="ProcessCard">
              <p>{`The APD is one of many permits a lease holder must get. It allows permit holders to move from exploration to development and production. Operators and lease holders need to get all the necessary permits and licenses for companies to be able to build their operations and extract oil and gas from federal lands.`}</p>
              <br />
              <p>{`During development and production, the BLM field office performs several inspections.  Inspections enforce lease terms and track health, safety, and environmental concerns. When operators extract oil or gas in paying quantities, the lease holder stops paying rent and starts paying `}<GlossaryTerm mdxType="GlossaryTerm">{`royalties`}</GlossaryTerm>{` to ONRR.`}</p>
            </ProcessCard>
            <ProcessCard step={5} name={'Decommission and reclaim'} mdxType="ProcessCard">
              <p>{`Before an oil and gas operation starts, the operator includes a Reclamation Plan in the Surface Use Plan that BLM must approve. Operators and lease holders must begin reclamation before an operation ends. `}</p>
              <br />
              <p>{`The lease holder also posts a bond of at least $10,000. BLM holds that bond during the operation to enforce lease terms and reclamation. The operator must conduct interim reclamation throughout the life of the operation. This concludes with appropriately plugging wells and restoring the ecosystem. The BLM field office performs inspections throughout the operation. Inspections ensure that interim reclamation takes place, wells are appropriately plugged, and the ecosystem is restored.`}</p>
            </ProcessCard>
            <ProcessCard name={'Rates and fees'} defaultExpanded={true} mdxType="ProcessCard">
              <ul>
                <li parentName="ul"><a parentName="li" {...{
                    "href": "/sites/update-redirects/how-revenue-works/revenues/#Oil-and-gas"
                  }}>{`Oil and gas rates and fees`}</a></li>
              </ul>
            </ProcessCard>
            <ProcessCard name={'Learn more'} defaultExpanded={true} mdxType="ProcessCard">
              <ul>
                <li parentName="ul"><a parentName="li" {...{
                    "href": "https://www.blm.gov/programs/energy-and-minerals/oil-and-gas/leasing"
                  }}>{`Leasing of onshore oil and gas resources `}<OpenInNewIcon style={{
                      fontSize: 20
                    }} mdxType="OpenInNewIcon" /></a></li>
              </ul>
            </ProcessCard>
          </Box>
        </Grid>
      </Grid>
    </OnshoreOilGasBackground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      